import { memo } from "react";
import type { ReactNode } from "react";
import { Button, Icon } from "@core/components";
import { cn } from "@core/utils/cn";
import { icons } from "@core/assets";

type PdfViewerHeaderProps = {
  fileName: string;
  fileVersion?: string;
  fileStatus?: string;
  tools?: ReactNode;
  onClose: () => void;
  onDownload: () => void;
};

export const PdfViewerHeader = memo(function PdfViewerHeader({
  fileName,
  fileVersion,
  fileStatus,
  tools,
  onClose,
  onDownload,
}: PdfViewerHeaderProps) {
  return (
    <header className="w-full h-[59px] bg-white border-b border-neutral-200 px-4 flex items-center justify-between flex-shrink-0">
      {/* Left: back + pdf icon + filename + version + status */}
      <div className="flex items-center gap-3">
        <Button
          type="button"
          aria-label="Back"
          onClick={onClose}
          leftIcon={icons["arrow-left"]}
          iconStrokeWidth={1.5}
          size="sm"
          variant="secondary"
        />
        <Icon name="file" className="w-6 h-6 text-red-500" />
        <span className="text-secondary-900 text-[17px] font-normal">
          {fileName}
        </span>
        {fileVersion != null && (
          <span className="text-neutral-400 text-xs">{fileVersion}</span>
        )}
        {fileStatus != null && (
          <span
            className={cn(
              "bg-neutral-200 text-neutral-500 text-xs px-2.5 py-1 rounded-lg",
            )}
          >
            {fileStatus}
          </span>
        )}
      </div>

      {/* Right: tools slot + download */}
      <div className="flex items-center gap-3">
        {tools != null && (
          <div className="flex items-center gap-1">{tools}</div>
        )}
        <Button
          type="button"
          aria-label="Download"
          onClick={onDownload}
          leftIcon={icons["download"]}
          iconStrokeWidth={1.5}
          size="sm"
          variant="secondary"
        />
      </div>
    </header>
  );
});
